
define('modules/application/calculationClasses/thermoRegulation',[
    "app",

    // Libs
    "backbone"
  ],

  function(app, Backbone) {

    var CalculationClass = {};

    CalculationClass.resetValues = function() {
      //Resetting values
      BticinoS4B.solution.thermoregulation.externalItems = [];
      BticinoS4B.solution.thermoregulation.zonesItems = [];
      BticinoS4B.Instances.Models.ApplicationModel.set("externalItems", []);
      BticinoS4B.Instances.Models.ApplicationModel.set("zonesItems", []);
    };

    CalculationClass.startAutomaticCalculation = function() {
      CalculationClass.resetValues();

      //Requesting model delivery
      window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);

      var automaticCalculationModel = {
        externalItems: [],
        zones: []
      };
      var plainPackages = [];
      var k = 1,
        l = 0;

      //Main control unit
      if (BticinoS4B.solution.thermoregulation.mainControlUnit) {
        automaticCalculationModel.externalItems.push({
          "progNumber": k,
          "packageClassId": BticinoS4B.solution.thermoregulation.mainControlUnit.get("packageClassId"),
          "packageClassLabel": BticinoS4B.solution.thermoregulation.mainControlUnit.get("packageClassLabel"),
          "productCode": BticinoS4B.solution.thermoregulation.mainControlUnit.get("productCode"),
          "quantity": 1,
          "type": "mainControlUnit"
        });
        plainPackages.push(BticinoS4B.solution.thermoregulation.mainControlUnit);
        k++;
      }

      //Pumps
      if ((BticinoS4B.solution.thermoregulation.pumps) && (BticinoS4B.solution.thermoregulation.pumps.get("value") > 0)) {
        for (l = 0; l < BticinoS4B.solution.thermoregulation.pumps.get("value"); l++) {
          automaticCalculationModel.externalItems.push({
            "progNumber": k,
            "packageClassId": BticinoS4B.solution.thermoregulation.pumps.get("packageClassId"),
            "packageClassLabel": BticinoS4B.solution.thermoregulation.pumps.get("packageClassLabel"),
            "productCode": BticinoS4B.solution.thermoregulation.pumps.get("productCode"),
            "quantity": 1,
            "type": "pump"
          });
          plainPackages.push(BticinoS4B.solution.thermoregulation.pumps);
          k++;
        }
      }

      //Outer Radio Probes
      if ((BticinoS4B.solution.thermoregulation.outerRadioProbe) && (BticinoS4B.solution.thermoregulation.outerRadioProbe.get("value") > 0)) {
        for (l = 0; l < BticinoS4B.solution.thermoregulation.outerRadioProbe.get("value"); l++) {
          automaticCalculationModel.externalItems.push({
            "progNumber": k,
            "packageClassId": BticinoS4B.solution.thermoregulation.outerRadioProbe.get("packageClassId"),
            "packageClassLabel": BticinoS4B.solution.thermoregulation.outerRadioProbe.get("packageClassLabel"),
            "productCode": BticinoS4B.solution.thermoregulation.outerRadioProbe.get("productCode"),
            "quantity": 1,
            "type": "outerRadioProbes"
          });
          plainPackages.push(BticinoS4B.solution.thermoregulation.outerRadioProbe);
          k++;
        }
      }

      //Outer Radio Interfaces
      if ((BticinoS4B.solution.thermoregulation.outerRadioProbe) && (BticinoS4B.solution.thermoregulation.outerRadioProbe.get("interfaceValue") > 0)) {
        for (l = 0; l < BticinoS4B.solution.thermoregulation.outerRadioProbe.get("interfaceValue"); l++) {
          automaticCalculationModel.externalItems.push({
            "progNumber": k,
            "packageClassId": BticinoS4B.solution.thermoregulation.outerRadioProbe.get("interfaceAttributes").packageClassId,
            "packageClassLabel": BticinoS4B.solution.thermoregulation.outerRadioProbe.get("interfaceAttributes").packageClassLabel,
            "productCode": BticinoS4B.solution.thermoregulation.outerRadioProbe.get("interfaceAttributes").productCode,
            "quantity": 1,
            "type": "outerRadioInterfaces"
          });
          plainPackages.push(BticinoS4B.solution.thermoregulation.outerRadioProbe.get("interfaceValue"));
          k++;
        }
      }

      if (BticinoS4B.solution.thermoregulation.zones) {
        var zoneCollection = BticinoS4B.solution.thermoregulation.zones.collection.models;
        for (var i = 0; i < zoneCollection.length; i++) {
          var zoneToSend = {};
          zoneToSend.zoneNumber = zoneCollection[i].get("number");
          zoneToSend.zoneName = zoneCollection[i].get("name");
          zoneToSend.board = "Q0";
          zoneToSend.ecoFunction = zoneCollection[i].get("ecoModeModel").get("ecoModeRequired") ? true : false;
          zoneToSend.ecoFunctionOneInterfaceForEachZone = (zoneCollection[i].get("ecoModeModel").get("oneInterfaceForEachZone")) ? (zoneCollection[i].get("ecoModeModel").get("oneInterfaceForEachZone")) : false;
          zoneToSend.ecoFunctionPackageClassId = zoneCollection[i].get("ecoModeModel").get("packageClassId") ? zoneCollection[i].get("ecoModeModel").get("packageClassId") : false;
          zoneToSend.items = [];

          var fetchedTypes = zoneCollection[i].get("solenoidValvesModel").fetchedTypes;
          var itemToAdd = {};
          for (l = 0; l < zoneCollection[i].get("solenoidValvesModel").get("combinedPlant").quantity; l++) {
            itemToAdd = {};
            itemToAdd.progNumber = k;
            itemToAdd.quantity = 1;
            itemToAdd.packageClassId = zoneCollection[i].get("solenoidValvesModel").get("combinedPlant").type;
            itemToAdd.type = 'solenoidValve';
            for (var j = 0; i < fetchedTypes.length; j++) {
              if (fetchedTypes[j].packageClassId === itemToAdd.packageClassId) {
                itemToAdd.productCode = fetchedTypes[j].productCode;
                itemToAdd.packageClassLabel = fetchedTypes[j].packageClassLabel;
                break;
              }
            }
            zoneToSend.items.push(itemToAdd);
            plainPackages.push(zoneCollection[i].get("solenoidValvesModel").get("combinedPlant"));
            k++;
          }

          for (l = 0; l < zoneCollection[i].get("solenoidValvesModel").get("heatingPlant").quantity; l++) {
            itemToAdd = {};
            itemToAdd.progNumber = k;
            itemToAdd.quantity = 1;
            itemToAdd.packageClassId = zoneCollection[i].get("solenoidValvesModel").get("heatingPlant").type;
            itemToAdd.type = 'solenoidValve';
            for (var y = 0; y < fetchedTypes.length; y++) {
              if (fetchedTypes[y].packageClassId === itemToAdd.packageClassId) {
                itemToAdd.productCode = fetchedTypes[y].productCode;
                itemToAdd.packageClassLabel = fetchedTypes[y].packageClassLabel;
                break;
              }
            }
            plainPackages.push(zoneCollection[i].get("solenoidValvesModel").get("heatingPlant"));
            zoneToSend.items.push(itemToAdd);
            k++;
          }

          for (l = 0; l < zoneCollection[i].get("solenoidValvesModel").get("breezingPlant").quantity; l++) {
            itemToAdd = {};
            itemToAdd.progNumber = k;
            itemToAdd.quantity = 1;
            itemToAdd.packageClassId = zoneCollection[i].get("solenoidValvesModel").get("breezingPlant").type;
            itemToAdd.type = 'solenoidValve';
            for (var x = 0; i < fetchedTypes.length; x++) {
              if (fetchedTypes[x].packageClassId === itemToAdd.packageClassId) {
                itemToAdd.productCode = fetchedTypes[x].productCode;
                itemToAdd.packageClassLabel = fetchedTypes[x].packageClassLabel;
                break;
              }
            }
            plainPackages.push(zoneCollection[i].get("solenoidValvesModel").get("breezingPlant"));
            zoneToSend.items.push(itemToAdd);
            k++;
          }

          if (zoneCollection[i].get("probesModel").get("packageClassId")) {
            itemToAdd = {};
            itemToAdd.progNumber = k;
            itemToAdd.quantity = 1;
            itemToAdd.packageClassId = zoneCollection[i].get("probesModel").get("packageClassId");
            itemToAdd.packageClassLabel = zoneCollection[i].get("probesModel").get("packageClassLabel");
            itemToAdd.productCode = zoneCollection[i].get("probesModel").get("productCode");
            itemToAdd.type = 'masterProbe';
            plainPackages.push(zoneCollection[i].get("probesModel"));
            zoneToSend.items.push(itemToAdd);
            k++;
          }

          for (l = 0; l < zoneCollection[i].get("probesModel").get("slaveProbes"); l++) {
            itemToAdd = {};
            itemToAdd.progNumber = k;
            itemToAdd.quantity = 1;
            itemToAdd.packageClassId = zoneCollection[i].get("probesModel").get("slaveProbesDetails").packageClassId;
            itemToAdd.packageClassLabel = zoneCollection[i].get("probesModel").get("slaveProbesDetails").packageClassLabel;
            itemToAdd.productCode = zoneCollection[i].get("probesModel").get("slaveProbesDetails").productCode;
            itemToAdd.type = 'slaveProbe';
            plainPackages.push(zoneCollection[i].get("probesModel").get("slavesProbesModel"));
            zoneToSend.items.push(itemToAdd);
            k++;
          }

          automaticCalculationModel.zones.push(zoneToSend);
        }
      }

      var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");

      BticinoS4B.Instances.Models.ApplicationModel.set("automaticCalculationModel", automaticCalculationModel);
      BticinoS4B.Instances.Models.ApplicationModel.set("automaticProducts", _.extend({}, BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel")));
      BticinoS4B.Instances.Models.ApplicationModel.set("plainPackages", plainPackages);
      dataProvider.addItems("automaticItems", this.requestAutomaticProducts());
      BticinoS4B.Instances.Models.ApplicationModel.set("automaticProducts", _.extend({}, BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel")));
      this.createConfiguration();
    };

    CalculationClass.requestAutomaticProducts = function() {
      var that = this,
        toReturn;

      var automaticProducts = {};
      var lastModelSentToOptimizationService = BticinoS4B.Instances.Models.ApplicationModel.get("lastModelSentToOptimizationService");
      var modelToSendToOptimizationService = JSON.stringify({
        token: window.BticinoS4B.token,
        itemList: BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts")
      });

      BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel", _.extend(BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel"), {
        additionalItems: []
      }));

      if (lastModelSentToOptimizationService !== modelToSendToOptimizationService) {
        BticinoS4B.Instances.Models.ApplicationModel.set("lastModelSentToOptimizationService", modelToSendToOptimizationService);
        $.ajax({
          type: "POST",
          datatype: "json",
          contentType: "application/json",
          async: false,
          url: "/WizardService.svc/getOptimizedItemList",
          data: modelToSendToOptimizationService,
          success: function(data) {
            // filtriamo gli alimentatori restituiti dal servizion di IdeaTech
            data.additionalItems = _.filter(data.additionalItems, function(iterableItem) {
              return iterableItem.productCode !== "E46ADCN";
            });

            var fetchProduct = function(fetched) {
              fetched.specialVars = JSON.parse(fetched.specialVars);
              _.extend(data.additionalItems[i], fetched);
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(fetched.packageClassId, function(fetchedProducts) {
                var mainProduct = _.filter(fetchedProducts.products, function(product) {
                  return product.mnemonic === 1;
                })[0];
                var secondaryProducts = _.filter(fetchedProducts.products, function(product) {
                  return product.mnemonic !== 1;
                });
                _.extend(data.additionalItems[i], mainProduct);
                data.additionalItems[i].secondaryProducts = secondaryProducts;
              });

            };

            for (var i = data.additionalItems.length - 1; i >= 0; i--)
              BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(data.additionalItems[i].packageClassId, fetchProduct);

            //Segnalazione Mantis 05098: TERMOREGOLAZIONE - Verifica del calcolo automatico alimentatori, il consumo non era moltiplicato per la quantità degli attuatori
            var automaticItemsCurrentConsumption = _.reduce(data.additionalItems, function(memo, iterableItem) {
              return memo + (iterableItem.specialVars.currentConsumption * iterableItem.quantity);
            }, 0);
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

            var powerSupplyCalculator = new that.powerSupplyCalculator(),
              totalCurrentConsumption = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel").get("totalCurrentConsumption"),
              neededPowerSupplies = powerSupplyCalculator.retrieveNecessaryProducts(totalCurrentConsumption + automaticItemsCurrentConsumption);

            if (!data.additionalItems)
              data.additionalItems = [];

            for (var z = neededPowerSupplies.length - 1; z >= 0; z--)
              data.additionalItems.push(neededPowerSupplies[z]);

            BticinoS4B.Instances.Models.ApplicationModel.set("lastAutomaticProductsRetrieved", data);
            toReturn = data.additionalItems;
          }
        });
      }

      automaticProducts = BticinoS4B.Instances.Models.ApplicationModel.get("lastAutomaticProductsRetrieved");
      BticinoS4B.Instances.Models.ApplicationModel.set("automaticCalculationModel", _.extend(BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel"), automaticProducts));

      var mergeDatas = function(data) {
        var model = _.extend({}, BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel"));
        var additionalItem = _.extend({}, BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel").additionalItems[x]);
        _.extend(additionalItem, data);

        //Mergin with the first wizardChoice
        if ((additionalItem.wizardChoices) && (additionalItem.wizardChoices.length > 0)) {
          if (additionalItem.wizardChoiceCode)
            _.extend(additionalItem, _.filter(additionalItem.wizardChoices, function(iterableItem) {
              return (iterableItem.wizardChoiceId === additionalItem.wizardChoiceCode);
            })[0]);
          else
            _.extend(additionalItem, additionalItem.wizardChoices[0]);
          delete additionalItem.wizardChoices;
        }

        if (!additionalItem.productLabel)
          additionalItem.productLabel = additionalItem.packageClassLabel;

        model.additionalItems[x] = additionalItem;

        BticinoS4B.Instances.Models.ApplicationModel.set("automaticCalculationModel", model);
      };

      if (BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel").additionalItems)
        for (var x = 0; x < BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel").additionalItems.length; x++)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel").additionalItems[x].packageClassId, mergeDatas);

      window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

      return BticinoS4B.Instances.Models.ApplicationModel.get("automaticCalculationModel").additionalItems;
    };

    CalculationClass.powerSupplyCalculator = Backbone.Model.extend({
      defaults: {
        idWizardChoice: 201
      },

      initialize: function() {
        this.fetchPackages();
        window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);
      },

      packagesRetrievedCallback: function(data) {
        var packages = data.packages;

        var valorizePackageWithProductAttributes = function(data) {
          data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
          data.products = _.filter(data.products, function(product) {
            return product.mnemonic === 1;
          });
          if (data.products.length > 0)
            data = data.products[0];
          _.extend(packages[i], data);

          var secondaryProducts = _.filter(data.products, function(product) {
            return (product.mnemonic !== 1);
          });

          packages[i].secondaryProducts = secondaryProducts;
        };

        //Converting specialVars to objects
        for (var i = packages.length - 1; i >= 0; i--) {
          if (packages[i].specialVars !== "")
            packages[i].specialVars = JSON.parse(packages[i].specialVars);

          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[i].packageClassId, valorizePackageWithProductAttributes);
        }

        var powerSupplies = _.filter(packages, function(iterablePackage) {
            return iterablePackage.specialVars.currentConsumption < 0;
          }),
          fetchedInterface = _.filter(packages, function(iterableInterface) {
            return iterableInterface.specialVars.isAnInterface;
          })[0];

        this.set("fetchedPowerSupplies", powerSupplies);
        this.set("fetchedInterface", fetchedInterface);
      },

      fetchPackages: function() {
        var that = this;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(this.get("idWizardChoice"), function(data) {
          that.packagesRetrievedCallback.apply(that, [data]);
        });
      },

      calculateNecessaryProducts: function(totalCurrentConsumption) {
        var packagesToProvide = [],
          fetchedPowerSupplies = this.get("fetchedPowerSupplies"),
          fetchedPowerSuppliesLength = fetchedPowerSupplies.length,
          fetchedInterface = this.get("fetchedInterface"),
          originalCurrentConsumption = totalCurrentConsumption,
          i = 0,
          j = 0,
          ratio = 0,
          optimizedPackagesToProvide = [],
          currentProvidedByPowerSupplies = 0;

        //Order powerSupplies by current
        fetchedPowerSupplies = _.sortBy(fetchedPowerSupplies, function(iterablePowerSupply) {
          return iterablePowerSupply.specialVars.currentConsumption;
        });

        for (i = 0; i < fetchedPowerSuppliesLength; i++) {
          if (totalCurrentConsumption >= 0) {
            ratio = -totalCurrentConsumption / fetchedPowerSupplies[i].specialVars.currentConsumption;
            mod = -totalCurrentConsumption % fetchedPowerSupplies[i].specialVars.currentConsumption;

            if ((ratio < 1) && ((i + 1) < fetchedPowerSuppliesLength) && (mod >= fetchedPowerSupplies[i + 1].specialVars.currentConsumption)) {} else {

              j = Math.ceil(ratio);

              //Add calculated power supply
              for (j = ((ratio < 1) ? Math.ceil(ratio) : Math.floor(ratio));
                (j > 0 && packagesToProvide.length < 7); j--) {
                packagesToProvide.push(fetchedPowerSupplies[i]);
                if (packagesToProvide.length > 1)
                  packagesToProvide.push(fetchedInterface);

                //Remove used current
                totalCurrentConsumption += fetchedPowerSupplies[i].specialVars.currentConsumption;
              }

              //If is the last available power supply fullfill the rest
              if ((i === (fetchedPowerSuppliesLength - 1)) && (totalCurrentConsumption > 0) && (packagesToProvide.length < 7))
                while (totalCurrentConsumption > 0) {
                  packagesToProvide.push(_.extend(fetchedPowerSupplies[i], {
                    validFor: []
                  }));
                  totalCurrentConsumption += fetchedPowerSupplies[i].specialVars.currentConsumption;
                }
            }
          }
        }
        this.set("packagesToProvide", packagesToProvide);
        return packagesToProvide;
      },

      retrieveNecessaryProducts: function(totalCurrentConsumption) {
        var necessaryProducts = this.calculateNecessaryProducts(totalCurrentConsumption),
          productsToReturn = [];

        necessaryProducts = _.groupBy(necessaryProducts, function(iterableProduct) {
          return iterableProduct.packageClassId;
        });

        for (var key in necessaryProducts) {
          productsToReturn.push(_.extend(necessaryProducts[key][0], {
            quantity: necessaryProducts[key].length,
            validFor: []
          }));
        }

        return productsToReturn;
      },

      deliverCurrent: function() {
        var collection = this.get("packagesToProvide") ? this.get("packagesToProvide") : [],
          collectionLength = collection.length,
          consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel"),
          mustDeliverExtraConsumption = false,
          consumption = 0,
          i = 0;

        //Delivering regular consumptions
        for (i = 0; i < collectionLength; i++)
          if (collection[i] && collection[i].specialVars)
            consumption += (collection[i].specialVars.currentConsumption * collection[i].quantity);

        if (consumption < 0)
          consumptionIndicatorModel.addSupplyCurrent(consumption);
        else
          consumptionIndicatorModel.addCurrentConsumption(consumption);
      }
    });



    CalculationClass.createConfiguration = function() {
      //Counters
      var productToAdd,
        productQuantity,
        validitiesLength,
        j, l, g,
        k = 1,
        counter = 0,
        optionalPackages = [],
        sobstitutionMatrix = [],
        plainPackages = BticinoS4B.Instances.Models.ApplicationModel.get("plainPackages");

      //Model to send
      var modelToSend = {
        token: window.BticinoS4B.token,
        items: []
      };

      //Submodel
      var externalItems = BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts").externalItems,
        externalItemsLength = externalItems ? externalItems.length : 0;

      var zones = BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts").zones,
        zonesLength = zones ? zones.length : 0;

      var additionalItems = BticinoS4B.Instances.Models.ApplicationModel.get("automaticProducts").additionalItems,
        additionalItemsLength = additionalItems ? additionalItems.length : 0;

      optionalPackages = BticinoS4B.Instances.Models.ApplicationModel.get("optionalPackages");
      var optionalPackagesLength = optionalPackages ? optionalPackages.length : 0;

      var plainProducts = [];
      modelToSend = [];

      //Adding external items to plain products array
      for (i = 0; i < externalItemsLength; i++) {
        productToAdd = _.extend({}, externalItems[i]);
        if (productToAdd.packageClassId !== "2002") {
          productQuantity = productToAdd.quantity;
          if (productToAdd.packageClassId === "2001") {
            productToAdd.zone = -201;
          } else {
            productToAdd.zone = 0;
          }

          for (j = 0; j < productQuantity; j++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({
              attachedProducts: []
            }, productToAdd));
            k++;
          }
        }
      }

      var externalRadioProbes = _.filter(plainProducts, function(item) {
        return item.packageClassId === "2071";
      });
      var interfacesRadioSensor = _.filter(plainProducts, function(item) {
        return item.packageClassId === "2072";
      });

      // counter = 0;
      // while (counter < externalRadioProbes.length) {
      //   for (i = 0; i < interfacesRadioSensor.length; i++) {
      //     if (interfacesRadioSensor[i].attachedProducts.length < 2) {
      //       var internalCounter = 0;
      //       var externalRadioProbeToAdd = _.extend({}, externalRadioProbes[counter]);
      //       externalRadioProbeToAdd.N = counter + 1;
      //       externalRadioProbeToAdd.Slots = 1;
      //       externalRadioProbeToAdd.idLink = externalRadioProbeToAdd.newProgNumber;
      //       delete externalRadioProbeToAdd.attachedProducts;
      //       delete externalRadioProbeToAdd.progNumber;
      //       //delete externalRadioProbeToAdd.productCode;
      //       interfacesRadioSensor[i].attachedProducts.push(_.extend({}, externalRadioProbeToAdd));
      //       counter++;
      //       if (counter === externalRadioProbes.length)
      //         break;
      //     }
      //   }
      // }

      var addExternalRadioProbes = function(item, counter) {
        var externalRadioProbeToAdd = _.extend({}, item);
        externalRadioProbeToAdd.N = counter + 1;
        externalRadioProbeToAdd.Slots = 1;
        externalRadioProbeToAdd.idLink = externalRadioProbeToAdd.newProgNumber;
        delete externalRadioProbeToAdd.attachedProducts;
        delete externalRadioProbeToAdd.progNumber;
        //delete externalRadioProbeToAdd.productCode;
        return externalRadioProbeToAdd;
      };

      counter = 0;
      while (counter < externalRadioProbes.length) {
        for (i = 0; i < interfacesRadioSensor.length; i++) {
          if (interfacesRadioSensor[i].attachedProducts.length < 2) {
            var externalRadioProbeToAddTmp=addExternalRadioProbes(externalRadioProbes[counter], counter);
            interfacesRadioSensor[i].attachedProducts.push(_.extend({}, externalRadioProbeToAddTmp));
            counter++;
            if (counter === externalRadioProbes.length)
              break;
            else
              if(interfacesRadioSensor[i].attachedProducts.length==1 && externalRadioProbes.length-counter>interfacesRadioSensor.length-(i+1)){
                var externalRadioProbeToAddTmpSecond=addExternalRadioProbes(externalRadioProbes[counter], counter);
                interfacesRadioSensor[i].attachedProducts.push(_.extend({}, externalRadioProbeToAddTmpSecond));
                counter++;
                if (counter === externalRadioProbes.length)
                  break;
              }
          }
        }
      }

      //Adding optional items to plain products array
      for (i = 0; i < optionalPackagesLength; i++) {
        var packageToAdd = _.extend({}, optionalPackages[i]);
        var packageProducts = packageToAdd.get("products").packagesByOptionalPackageId;
        var packageProductsLength = packageProducts.length;

        for (l = 0; l < packageProductsLength; l++) {
          productToAdd = _.extend(packageProducts[l]);
          productQuantity = 0;
          var productPackageClassId = "";

          if (productToAdd.attributes) {
            productQuantity = productToAdd.get("value");
            productPackageClassId = productToAdd.get("packageClassId");
            packageClassLabel = productToAdd.get("packageClassLabel");
            productCode = productToAdd.get("productCode");

          } else {
            productQuantity = productToAdd.value;
            productPackageClassId = productToAdd.packageClassId;
            packageClassLabel = productToAdd.packageClassLabel;
            productCode = productToAdd.productCode;
          }
          var zoneValue = 0;

          //Exception for IR interface
          if (productPackageClassId === "2101")
            zoneValue = 99;

          productToAdd = {
            zone: zoneValue,
            packageClassId: productPackageClassId
          };

          for (j = 0; j < productQuantity; j++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({}, productToAdd));
            k++;
          }
        }
      }

      //Adding zone items to plain products array
      for (i = 0; i < zonesLength; i++) {
        var zoneLength = zones[i].items.length;

        for (j = 0; j < zoneLength; j++) {
          productToAdd = _.extend({}, zones[i].items[j]);
          productQuantity = productToAdd.quantity;
          //delete productToAdd.quantity;

          productToAdd.zone = i + 1;
          productToAdd.aux  = "";

          for (l = 0; l < productQuantity; l++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({}, productToAdd));
            k++;
          }

        }
      }

      //Adding autocalculated items
      var iterator = function(item) {
        return item.ProgressiveNumber;
      };

      for (i = 0; i < additionalItemsLength; i++) {
        validitiesLength = additionalItems[i].validFor.length;

        for (j = 0; j < validitiesLength; j++)
          additionalItems[i].validFor[j] = _.sortBy(additionalItems[i].validFor[j], iterator);

        if (validitiesLength === 0) {
          productToAdd = _.extend({}, additionalItems[i]);
          productQuantity = productToAdd.quantity;
          //delete productToAdd.quantity;

          productToAdd.zone = 0;
          productToAdd.aux = "";

          for (l = 0; l < productQuantity; l++) {
            productToAdd.newProgNumber = k;
            plainProducts.push(_.extend({}, productToAdd));
            k++;
          }
        }
      }

      //Adding autocalculated items with validities
      for (i = 0; i < additionalItemsLength; i++) {
        var validities = additionalItems[i].validFor;
        validitiesLength = validities.length;
        productToAdd = _.extend({}, additionalItems[i]);
        productQuantity = productToAdd.quantity;
        //delete productToAdd.quantity;

        for (j = 0; j < validitiesLength; j++) {
          for (t = 0; t < validities[j].length; t++) {
            for (l = 0; l < plainProducts.length; l++) {
              if (validities[j][t].ProgressiveNumber === plainProducts[l].progNumber) {
                validities[j][t].quantity = plainProducts[l].quantity;
                break;
              }
            }
          }
        }

        for (j = 0; j < productQuantity; j++) {
          productToAdd.newProgNumber = k;

          if (validities[j]) {
            if (j < validitiesLength)
              productToAdd.attachedProducts = validities[j];

            var validitiesToReAdd = [];
            var validityToReAdd;

            var occupiedSlots = 0;
            for (l = 0; l < productToAdd.attachedProducts.length; l++) {
              for (t = 0; t < productToAdd.attachedProducts[l].quantity; t++) {

                switch (productToAdd.packageClassId) {
                  case "2031":
                    actuatorsSlots = 2;
                    break;
                  case "2032":
                    actuatorsSlots = 4;
                    break;
                  case "2033":
                    actuatorsSlots = 1;
                    break;
                  case "2034":
                    actuatorsSlots = 2;
                    break;
                }

                if (occupiedSlots < actuatorsSlots)
                  if (productToAdd.attachedProducts[l].ProgressiveNumber !== null) {
                    for (g = 0; g < plainProducts.length; g++) {
                      if ((!plainProducts[g].used) && (plainProducts[g].progNumber === productToAdd.attachedProducts[l].ProgressiveNumber)) {
                        validityToReAdd = _.extend({}, productToAdd.attachedProducts[l]);
                        validityToReAdd.idLink = plainProducts[g].newProgNumber;
                        validityToReAdd.packageClassId = plainProducts[g].packageClassId;
                        plainProducts[g].used = true;
                        occupiedSlots += productToAdd.attachedProducts[l].Slots;
                        validitiesToReAdd.push(validityToReAdd);
                        break;
                      }
                    }
                  } else
                    break;
              }
            }

            productToAdd.attachedProducts = validitiesToReAdd.slice(0);
            plainProducts.push(_.extend({}, productToAdd));
            k++;
          }
        }
      }

      /* Assigning values for N */
      var zoneIds = _.uniq(_.map(plainProducts, function(el) {
        return el.zone;
      }));
      var productClassIds = _.uniq(_.map(plainProducts, function(el) {
        return el.packageClassId;
      }));
      var zoneIdsLength = zoneIds.length;
      var productClassIdsLength = productClassIds.length;
      var plainProductsLength = plainProducts.length;

      for (var x = 0; x < zoneIdsLength; x++) {
        for (i = 0; i < productClassIdsLength; i++) {
          var nCounter = 1;
          var nCounterSlaveProbes = 1;
          var nCounterSolenoidValves = 1;
          var nCounterOuterRadioProbes = 1;
          var nCounterOuterRadioInterfaces = 1;
          for (j = 0; j < plainProductsLength; j++) {
            if (
              (plainProducts[j].zone === zoneIds[x]) /*&& (plainProducts[j].packageClassId === productClassIds[i])*/ && (
                (!plainProducts[j].validFor) || ((plainProducts[j].validFor) && (plainProducts[j].validFor.length === 0)))) {

              if (plainProducts[j].type == 'masterProbe') {
                plainProducts[j].N = 0;
              } else if (plainProducts[j].type == 'slaveProbe') {
                plainProducts[j].N = nCounterSlaveProbes;
                nCounterSlaveProbes++;
                nCounter = nCounterSlaveProbes;
              } else if (plainProducts[j].type == 'solenoidValve') {
                plainProducts[j].N = nCounterSolenoidValves;
                nCounterSolenoidValves++;
                nCounter = nCounterSolenoidValves;
              } else if (plainProducts[j].type == 'outerRadioProbes') {
                plainProducts[j].N = nCounterOuterRadioProbes;
                nCounterOuterRadioProbes++;
                nCounter = nCounterOuterRadioProbes;
              } else if (plainProducts[j].type == 'outerRadioInterfaces') {
                plainProducts[j].N = nCounterOuterRadioInterfaces;
                nCounterOuterRadioInterfaces++;
                nCounter = nCounterOuterRadioInterfaces;
              } else {
                plainProducts[j].N = nCounter;
                nCounter++;
              }

            }
          }
        }
      }

      for (i = 0; i < plainProductsLength; i++) {

        var objectToAdd = {
          progNumber: plainProducts[i].newProgNumber,
          packageClassId: plainProducts[i].packageClassId,
          packageClassLabel: plainProducts[i].packageClassLabel,
          itemcode: plainProducts[i].productCode,
          slot: []
        };

        if (plainProducts[i].type == 'pump') {
          objectToAdd.Z = 0;
        } else if (plainProducts[i].type == 'outerRadioProbes') {
          objectToAdd.Z = 0;
        } else if (plainProducts[i].type == 'outerRadioInterfaces') {
          objectToAdd.Z = 0;
        } else if (plainProducts[i].zone !== undefined) {
          objectToAdd.Z = plainProducts[i].zone;
        }

        if (plainProducts[i].packageClassId === "2002") {
          objectToAdd.N = 0;
        }
        if (plainProducts[i].type === "masterProbe") {
          objectToAdd.N = 0;
        } else if (plainProducts[i].N !== undefined) {
          objectToAdd.N = plainProducts[i].N;
        }

        if (plainProducts[i].attachedProducts) {
          for (j = 0; j < plainProducts[i].attachedProducts.length; j++) {
            for (l = 0; l < plainProducts[i].attachedProducts[j].Slots; l++) {

              var finalProductToAdd = _.extend({}, plainProducts[i].attachedProducts[j]);

              finalProductToAdd.Z = finalProductToAdd.Zone ? finalProductToAdd.Zone : 0;
              finalProductToAdd.N = finalProductToAdd.N ? finalProductToAdd.N : 0;

              delete finalProductToAdd.ProgressiveNumber;
              delete finalProductToAdd.Slots;
              delete finalProductToAdd.zone;
              delete finalProductToAdd.type;
              delete finalProductToAdd.quantity;

              objectToAdd.slot.push(_.extend({}, finalProductToAdd));
            }
          }
        }

        // funzione per aggiungere i contatti liberi alle interfacce basic e DIN
        if ((plainProducts[i].packageClassId == '2081' || plainProducts[i].packageClassId == '2082' ) && plainProducts[i].validFor) {
          var finalProductToAdd;
          for(j = 0; j < plainProducts[i].validFor[0].length; j++) {
            finalProductToAdd = {
                          "idLink": -(j+1),
                          "progNumber": -(j+1),
                          "quantity": 1,
                          "packageClassId": "4501",
                          "packageClassLabel": "Contatto libero in ingresso N.C.",
                          "productCode": "__ND__11",
                          "N": undefined,//plainProducts[i].validFor[0][j].Zone,
                          "Z": undefined//plainProducts[i].validFor[0][j].Zone
            };
            objectToAdd.slot.push(_.extend({}, finalProductToAdd));
          }
        }

        modelToSend.push(objectToAdd);
      }

      // funzione per aggiungere la Z e la N ai contatti delle interfacce
      var nCounterContacts = 1;
      for (i = 0; i < zonesLength; i++) {
        // controllo se la zona ha la funzione ecoMode
        if (zones[i].ecoFunction) {
          var isExclusive = zones[i].ecoFunctionOneInterfaceForEachZone;
          var packageClassId = zones[i].ecoFunctionPackageClassId;
          var contactAdded = false;
          // cerco le interfacce a cui colelgare i contatti
          for(var j = 0; j < modelToSend.length; j++) {
            if ((modelToSend[j].packageClassId == packageClassId) && (!modelToSend[j].interfaceIsFull)){
              for (var x = 0; x < modelToSend[j].slot.length; x++){
                if ((!modelToSend[j].slot[x].Z) && (!modelToSend[j].slot[x].N)){
                  modelToSend[j].slot[x].Z = zones[i].zoneNumber;
                  modelToSend[j].slot[x].N = nCounterContacts;
                  nCounterContacts++;
                  contactAdded = true;
                  if ((x == modelToSend[j].slot.length-1) || (isExclusive)) { modelToSend[j].interfaceIsFull = true; }
                  break;
                }
              }
            }
            if (contactAdded) { break; }
          }
        }

      }

      // elimino gli slot undefined aggiunti dalla variabile ValidFor
      
      for(var j = 0; j < modelToSend.length; j++) {
        if ((modelToSend[j].packageClassId == '2081' || modelToSend[j].packageClassId == '2082' )) {
          for (var x = 0; x < modelToSend[j].slot.length; x++){
            if ((!modelToSend[j].slot[x].Z) && (!modelToSend[j].slot[x].N)){
              modelToSend[j].slot.splice(x,1);
            }
          }
        }
      }

      for (i = 0; i < modelToSend.length; i++) {
        if ((modelToSend[i].slot) && (modelToSend[i].slot.length > 0)) {
          for (j = 0; j < modelToSend[i].slot.length; j++) {
            if (modelToSend[i].slot[j]){
            for (l = 0; l < modelToSend.length; l++) {
              if (modelToSend[l].progNumber === modelToSend[i].slot[j].idLink) {
                modelToSend[i].slot[j].N = modelToSend[l].N;
                break;
              }
            }
          }
          }
        }
      }

      var configuration;
      var getProductDetails = function(packageDetails) {
        configuration.items[i] = _.extend(configuration.items[i], packageDetails);
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(configuration.items[i].packageClassId, function(productDetails) {
          productDetails.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productDetails.products);

          //Transforming quantity
          configuration.items[i] = _.extend(configuration.items[i], productDetails.products[0]);

          //Transforming quantity
          if (configuration.items[i].Qta) {
            configuration.items[i].quantity = parseInt(configuration.items[i].Qta, 10);
            delete configuration.items[i].Qta;
          }

          //merging with wizard choice
          if ((configuration.items[i].wizardChoices) && (configuration.items[i].wizardChoices.length > 0)) {
            _.extend(configuration.items[i], configuration.items[i].wizardChoices[0]);
            delete configuration.items[i].wizardChoices;
          }

        });
      };
      var getAddedProductDetails = function(packageDetails) {
        configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], packageDetails);
        BticinoS4B.Instances.Models.ApplicationModel.getProducts(configuration.itemsConfiguratorAdded[i].packageClassId, function(productDetails) {
          productDetails.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productDetails.products);

          //Transforming quantity
          configuration.itemsConfiguratorAdded[i] = _.extend(configuration.itemsConfiguratorAdded[i], productDetails.products[0]);

          //Transforming quantity
          if (configuration.itemsConfiguratorAdded[i].Qta) {
            configuration.itemsConfiguratorAdded[i].quantity = parseInt(configuration.itemsConfiguratorAdded[i].Qta, 10);
            delete configuration.itemsConfiguratorAdded[i].Qta;
          }

          //merging with wizard choice
          if ((configuration.itemsConfiguratorAdded[i].wizardChoices) && (configuration.itemsConfiguratorAdded[i].wizardChoices.length > 0)) {
            _.extend(configuration.itemsConfiguratorAdded[i], configuration.itemsConfiguratorAdded[i].wizardChoices[0]);
            delete configuration.itemsConfiguratorAdded[i].wizardChoices;
          }

        });
      };
      var getPackageDetails = function(data) {
        configuration = data.d;
        var itemsLength = data.d.items.length;

        for (i = 0; i < itemsLength; i++)
          configuration.items[i].progNumber = parseInt(configuration.items[i].progNumber, 10);

        configuration.items = _.sortBy(configuration.items, function(element) {
          return element.progNumber;
        });

        for (i = 0; i < itemsLength; i++)
          _.extend(modelToSend[i], configuration.items[i]);

        configuration.items = modelToSend;
        var mergePackageDetails = function(packageDetails) {
          configuration.items[i] = _.extend(configuration.items[i], packageDetails);
        };

        for (i = 0; i < itemsLength; i++) {
          for (j = 0; j < plainPackages.length; j++) {
            if ((plainPackages[j]) && (plainPackages[j].attributes !== undefined)) {
              if (configuration.items[i].packageClassId === plainPackages[j].get("packageClassId")) {
                _.extend(configuration.items[i], plainPackages[j].attributes);
                break;
              }
            } else {
              if ((configuration.items[i]) && (plainPackages[j]) && (configuration.items[i].packageClassId === plainPackages[j].packageClassId)) {
                _.extend(configuration.items[i], plainPackages[j]);
                break;
              }
            }

            if (j === (plainPackages.length - 1))
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(configuration.items[i].packageClassId, mergePackageDetails);
          }
        }

        for (i = 0; i < configuration.items.length; i++)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.items[i].packageClassId, getProductDetails);

        for (i = 0; i < configuration.itemsConfiguratorAdded.length; i++)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(configuration.itemsConfiguratorAdded[i].packageClassId, getAddedProductDetails);

        BticinoS4B.Instances.Models.ApplicationModel.set("configurationModel", configuration);

        var configurationModel = BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").items;
        var configurationModelLength = configurationModel.length;
        var completeConfigurationModel = new Backbone.Model();

        for (i = 0; i < configurationModelLength; i++) {
            if (configurationModel[i].slot.length > 0) {
              for (j = 0; j < configurationModel[i].slot.length; j++) {
                if (configurationModel[i].slot[j]) {
                for (l = 0; l < configurationModel.length; l++) {
                  if (configurationModel[l].progNumber === configurationModel[i].slot[j].idLink) {
                    configurationModel[i].slot[j] = _.extend(configurationModel[i].slot[j], configurationModel[l]);
                    break;
                  }
                }
              }
            }
          }
        }

        var actuators = _.filter(configurationModel, function(element) {
          return ((element.slot) && (element.slot.length > 0) && (element.packageClassId !== "2072") && (element.packageClassId !== "2101") && (element.packageClassId !== "2081") && (element.packageClassId !== "2082"));
        });
        var outOfZoneArticles = _.difference(configurationModel, actuators);
        outOfZoneArticles = _.filter(outOfZoneArticles, function(element) {
          return (!element.Z);
        });
        var zones = _.difference(configurationModel, actuators, outOfZoneArticles);
        var zoneNumbers = _.sortBy(_.uniq(_.map(zones, function(element) {
          return element.Z;
        })), function(element) {
          return element;
        });

        var iterator = function(element) {
          return (element.Z === zoneNumbers[i]);
        };

        for (i = 0; i < zoneNumbers.length; i++) {
          zoneNumbers[i] = {
            number: zoneNumbers[i],
            items: _.filter(zones, iterator)
          };
        }
        completeConfigurationModel.set("actuators", actuators);
        completeConfigurationModel.set("outOfZoneArticles", outOfZoneArticles);
        BticinoS4B.Instances.Models.ApplicationModel.set("getZoneName", function(zoneNumber) {
          return $.i18n._("IDS_WTR1001_9001") + " " + zoneNumber;
        });
        completeConfigurationModel.set("zoneArticles", zoneNumbers);
        BticinoS4B.Instances.Models.ApplicationModel.set("completeConfiguration", completeConfigurationModel);

      };

      var lastModelSent = BticinoS4B.Instances.Models.ApplicationModel.get("lastModelSentToConfigurationService");

      objectToSend = JSON.stringify({
        catalogueId: BticinoS4B.Instances.Models.ApplicationModel.get("catalogId"),
        token: window.BticinoS4B.token,
        items: modelToSend
      });

      if (lastModelSent !== objectToSend) {
        BticinoS4B.Instances.Models.ApplicationModel.set("lastModelSentToConfigurationService", objectToSend);
        $.ajax({
          type: "POST",
          datatype: "json",
          contentType: "application/json",
          async: false,
          url: "/btreport/JSonInterface.asmx/JSonMakeConfigurator",
          data: objectToSend,
          success: function(data) {
            BticinoS4B.Instances.Models.ApplicationModel.set("lastConfiguration", JSON.stringify(data));
            getPackageDetails(data);
          }
        });
      }

      var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");
      dataProvider.addItems("configurationItems", BticinoS4B.Instances.Models.ApplicationModel.get("configurationModel").itemsConfiguratorAdded);

      window.BticinoS4B.eventAggregator.trigger("recalculation:complete");
    };

    CalculationClass.retrieveModels = function() {
      var modelToSave = {};

      CalculationClass.resetValues();

      window.BticinoS4B.eventAggregator.trigger("modelDeliver:request", this);

      /* Setting systemId */
      modelToSave.systemId = '#2';
      modelToSave.inserted = BticinoS4B.solution.thermoregulation.inserted;

      /*Preparing for saving*/
      modelToSave.accessoryLine = {};
      if (BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine")) modelToSave.accessoryLine.line = BticinoS4B.Instances.Models.ApplicationModel.get("choosenLine").id;
      if (BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor")) modelToSave.accessoryLine.color = BticinoS4B.Instances.Models.ApplicationModel.get("choosenColor").id;

      var retrieveMainControlUnit = function(mainControlUnit) {
        var toReturn = {};
        toReturn.packageClassId = mainControlUnit.get ? mainControlUnit.get("packageClassId") : mainControlUnit.packageClassId;
        toReturn.contacts = [];

        if (mainControlUnit.get("specialVars") && mainControlUnit.get("specialVars").contacts)
          for (var i = mainControlUnit.get("specialVars").contacts.length - 1; i >= 0; i--)
            toReturn.contacts.push({
              connectedTo: mainControlUnit.get("specialVars").contacts[i].connectedTo
            });

        return toReturn;
      };

      if (BticinoS4B.solution.thermoregulation.mainControlUnit /*.get("packageClassId")*/ )
        modelToSave.mainControlUnit = retrieveMainControlUnit(BticinoS4B.solution.thermoregulation.mainControlUnit);

      if (BticinoS4B.solution.thermoregulation.pumps /*.get("value")*/ ) modelToSave.pumps = BticinoS4B.solution.thermoregulation.pumps.get("value");

      modelToSave.outerRadioProbe = {};
      if (BticinoS4B.solution.thermoregulation.outerRadioProbe /*.get("value")*/ ) modelToSave.outerRadioProbe.quantity = BticinoS4B.solution.thermoregulation.outerRadioProbe.get("value");
      if (BticinoS4B.solution.thermoregulation.outerRadioProbe /*.get("interfaceValue")*/ ) modelToSave.outerRadioProbe.interfaceQuantity = BticinoS4B.solution.thermoregulation.outerRadioProbe.get("interfaceValue");

      modelToSave.zones = [];
      var zonesCollection = [];
      if (BticinoS4B.solution.thermoregulation.zones) {
        zonesCollection = BticinoS4B.solution.thermoregulation.zones.collection;
      }

      _.each(zonesCollection.models, function(zone) {

        var zoneToAdd = {};
        zoneToAdd.solenoidValvesModel = {};

        zoneToAdd.name = zone.get("name");
        zoneToAdd.number = zone.get("number");

        if (zone.get("solenoidValvesModel").get("combinedPlantType")) zoneToAdd.solenoidValvesModel.combinedPlantType = zone.get("solenoidValvesModel").get("combinedPlantType");

        zoneToAdd.solenoidValvesModel.combinedPlant = {};
        if (zone.get("solenoidValvesModel").get("combinedPlant")) zoneToAdd.solenoidValvesModel.combinedPlant.quantity = zone.get("solenoidValvesModel").get("combinedPlant").quantity;
        if (zone.get("solenoidValvesModel").get("combinedPlant")) zoneToAdd.solenoidValvesModel.combinedPlant.type = zone.get("solenoidValvesModel").get("combinedPlant").type;

        zoneToAdd.solenoidValvesModel.heatingPlant = {};
        if (zone.get("solenoidValvesModel").get("heatingPlant")) zoneToAdd.solenoidValvesModel.heatingPlant.quantity = zone.get("solenoidValvesModel").get("heatingPlant").quantity;
        if (zone.get("solenoidValvesModel").get("heatingPlant")) zoneToAdd.solenoidValvesModel.heatingPlant.type = zone.get("solenoidValvesModel").get("heatingPlant").type;

        zoneToAdd.solenoidValvesModel.breezingPlant = {};
        if (zone.get("solenoidValvesModel").get("breezingPlant")) zoneToAdd.solenoidValvesModel.breezingPlant.quantity = zone.get("solenoidValvesModel").get("breezingPlant").quantity;
        if (zone.get("solenoidValvesModel").get("breezingPlant")) zoneToAdd.solenoidValvesModel.breezingPlant.type = zone.get("solenoidValvesModel").get("breezingPlant").type;

        zoneToAdd.probesModel = {};
        zoneToAdd.probesModel.slaveProbesDetails = {};

        if ((zone.get("probesModel")) && (zone.get("probesModel").get("packageClassId")))
          zoneToAdd.probesModel.packageClassId = zone.get("probesModel").get("packageClassId");

        if ((zone.get("probesModel")) && (zone.get("probesModel").get("useMainControlUnitAsMasterProbe")))
          zoneToAdd.probesModel.useMainControlUnitAsMasterProbe = zone.get("probesModel").get("useMainControlUnitAsMasterProbe");

        if ((zone.get("probesModel")) && (zone.get("probesModel").get("slaveProbesDetails")))
          zoneToAdd.probesModel.slaveProbesDetails.packageClassId = zone.get("probesModel").get("slaveProbesDetails").packageClassId;

        if ((zone.get("probesModel")) && (zone.get("probesModel").get("slaveProbesDetails")))
          zoneToAdd.probesModel.slaveProbes = zone.get("probesModel").get("slaveProbes");

        if ((zone.get("probesModel")) && (zone.get("probesModel").get("fancoilPresent")))
          zoneToAdd.probesModel.fancoilPresent = zone.get("probesModel").get("fancoilPresent");

        zoneToAdd.ecoModeModel = {};
        if (zone.get("ecoModeModel")) zoneToAdd.ecoModeModel.inhibited = zone.get("ecoModeModel").get("inhibited");
        if (zone.get("ecoModeModel")) zoneToAdd.ecoModeModel.ecoModeRequired = zone.get("ecoModeModel").get("ecoModeRequired");
        if (zone.get("ecoModeModel")) zoneToAdd.ecoModeModel.packageClassId = zone.get("ecoModeModel").get("packageClassId");
        if (zone.get("ecoModeModel")) zoneToAdd.ecoModeModel.oneInterfaceForEachZone = zone.get("ecoModeModel").get("oneInterfaceForEachZone") ? true : false;

        modelToSave.zones.push(zoneToAdd);
      });

      modelToSave.optionals = [];
      if (BticinoS4B.solution.thermoregulation.optionalPackages) {
        _.each(BticinoS4B.solution.thermoregulation.optionalPackages, function(optionalPackage) {
          _.each(optionalPackage.get("products").packagesByOptionalPackageId, function(optionalProduct) {
            if ((optionalProduct.get) && (optionalProduct.get("value")) && (optionalProduct.get("value") > 0)) {
              var optionalToAdd = {};
              optionalToAdd.productCode = optionalProduct.get("productCode");
              optionalToAdd.value = optionalProduct.get("value");
              modelToSave.optionals.push(optionalToAdd);
            }
          });
        });
      }
      return modelToSave;
    };

    // Required, return the module for AMD compliance
    return CalculationClass;

  });